// Chave Pix dentro do `nativeFlowMessage` de uma mensagem interativa do WhatsApp — a
// cobranca "Copiar chave Pix" que o fornecedor manda pelo WhatsApp Business.
//
// Peca unica de proposito: o backend usa pra escrever o texto da mensagem
// (`fluxo-nativo.service.ts`) e a tela usa pra desenhar o cartao com o botao de copiar
// a partir do envelope gravado em `metadata.fluxo_nativo`. Duas leituras separadas
// fariam o texto e o cartao discordarem calados.
//
// Formato visto cru (msg 88323, 23/10/2026): botao `payment_info` com
// `payment_settings[].pix_static_code {key, key_type, merchant_name}`. A busca e' por
// FORMA (objeto com `key` + `key_type`, texto que comeca com `000201`), nao por caminho
// fixo — nao ha fonte oficial, e cobranca COM valor ainda nao foi vista.

export interface ChavePixFluxo {
  chave: string;
  // Como o WhatsApp manda: CNPJ, CPF, PHONE, EMAIL, EVP...
  tipo: string;
  nome: string;
}

export interface PixDoFluxo {
  chaves: ChavePixFluxo[];
  copiaECola: string[];
  // `display_text` dos botoes, pro que nao for Pix.
  rotulos: string[];
}

// Visita todo objeto/texto aninhado.
function visitar(no: unknown, fn: (v: unknown) => void, prof = 0): void {
  if (prof > 12 || no == null) return;
  fn(no);
  if (Array.isArray(no)) no.forEach((x) => visitar(x, fn, prof + 1));
  else if (typeof no === 'object') Object.values(no as Record<string, unknown>).forEach((x) => visitar(x, fn, prof + 1));
}

// Recebe o envelope ja decodificado (o `metadata.fluxo_nativo`: `{botoes, params}`).
export function pixDoFluxoNativo(bruto: unknown): PixDoFluxo {
  const r: PixDoFluxo = { chaves: [], copiaECola: [], rotulos: [] };
  visitar(bruto, (v) => {
    if (typeof v === 'string') {
      if (/^000201/.test(v) && !r.copiaECola.includes(v)) r.copiaECola.push(v);
      return;
    }
    if (typeof v !== 'object' || Array.isArray(v)) return;
    const o = v as Record<string, unknown>;
    if (typeof o.key === 'string' && o.key.trim() && typeof o.key_type === 'string') {
      const chave = o.key.trim();
      if (!r.chaves.some((c) => c.chave === chave)) {
        r.chaves.push({ chave, tipo: o.key_type, nome: typeof o.merchant_name === 'string' ? o.merchant_name.trim() : '' });
      }
    }
    if (typeof o.display_text === 'string' && o.display_text.trim()) r.rotulos.push(o.display_text.trim());
  });
  return r;
}

export function rotuloTipoChavePix(tipo: string): string {
  const t = tipo.toUpperCase();
  if (t.includes('CNPJ')) return 'CNPJ';
  if (t.includes('CPF')) return 'CPF';
  if (t.includes('PHONE') || t.includes('TELEFONE')) return 'telefone';
  if (t.includes('EMAIL')) return 'e-mail';
  if (t.includes('EVP') || t.includes('RANDOM') || t.includes('ALEATORIA')) return 'aleatória';
  return tipo;
}
